import { Environment } from './environment.type';

export const environment: Environment = {
  production: false,
  sentryEnabled: false,
  environmentTag: 'develop',
  graphqlUrl: 'https://dev.api.yload.eu/graphql',
  // graphqlUrl: 'http://localhost:6010/graphql',
  apiUrl: 'https://dev.api.yload.eu',
  workloadApiUrl: 'https://api.dev.yload.eu/api/v1',
  // workloadApiUrl: 'http://localhost:3000/api/v1',
  hereMapsApiKey: 'U79RgLO3fX6C90KSYIBgr3tXV52OHiBu-Sk3ymbSxgo',
  mapsKey: 'AIzaSyB3fg7I46AgXz_taoYveYc6-AUZo5uK9m0',
  appBaseUrl: 'https://network.dev.yload.eu',
  socketHost: 'beta.dev.yload.eu',
  gaId: 'G-4J3STDPF5G',
  uploadsUrl: 'https://dev.api.yload.eu/uploads',
  comeChatAppId: '25892830a5bce6e1',
  comeChatRegion: 'eu',
  comeChatAuthKey: '82b6a979abbe580e61ecc94fa3035e3d67880a8c',
  cometChatRestApiKey: '8846348d92ff8fee75720b62b53f71491d69b211',
  mapboxToken:
    'pk.eyJ1Ijoid2JyMDkiLCJhIjoiY2xzazYwaW91MDA0MzJqbm81OXFndWkycyJ9.IIzZM3ojJiKfFcTED96Pmw',
  oneSignalAppId: '52338764-c9a9-456f-9dfb-9b2cc554eead',
  userGuidingAppId: '8A310703811XID',
  tenantFrachtRomaniaId: 'b56a257a-d027-4bd9-80be-1942d7face89',
  tenantFrachtProjectCargoId: '26a5df2c-c591-4dbb-b6c0-db250f8af991',
};
